import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { FullTruckLoad } from '/screens/';

export default function FTLPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight ftl, full truckload, full truck load, ftl services, ftl logistics, full truckload services"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Full Truckload (FTL) Shipping"
        description="Get free, instantly bookable full truckload (FTL) shipping rates for your freight. Work with our network of pre-qualified carriers for your drop-trailer, reefer, flatbed, and other truckload needs."
        canonical="https://loadsmart.com/ftl/"
        openGraph={{
          url: 'https://loadsmart.com/ftl/',
        }}
      />
      <FullTruckLoad />
    </>
  );
}
